<template>
  <v-container fluid class="service-page pa-4 pa-md-6">
    <Head>
      <template v-if="breadcrumb" v-slot:breadcrumb>
        {{ breadcrumb }}
      </template>
      <template v-slot:title>
        <v-btn icon :to="{ name: backRoute }" class="mr-1" aria-label="กลับ">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-icon v-if="icon" :color="iconColor" class="mr-1">{{ icon }}</v-icon>{{ title }}
      </template>
      <template v-if="subtitle" v-slot:subtitle>
        {{ subtitle }}
      </template>
    </Head>

    <template v-if="available">
      <slot />
    </template>

    <v-card v-else flat class="industrial-panel service-panel--empty">
      <v-card-text class="text-center py-12">
        <v-icon size="64" color="grey lighten-1">mdi-domain-off</v-icon>
        <div class="mt-4 text-h6 grey--text text--darken-1">
          ฟีเจอร์นี้ยังไม่พร้อมใช้งานสำหรับอาคารของคุณ
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import Head from '@/components/layout/Head.vue'

export default {
  name: 'ServicePageLayout',
  components: { Head },
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: '' },
    icon: { type: String, default: '' },
    iconColor: { type: String, default: 'primary' },
    breadcrumb: { type: String, default: '' },
    backRoute: { type: String, default: 'overview' },
    available: { type: Boolean, default: true },
  },
}
</script>

<style scoped>
.service-page {
  max-width: 1600px;
}

.service-panel--empty {
  margin-top: 8px;
}
</style>

<style>
.industrial-tabs .v-tabs-bar {
  background: transparent !important;
  border-bottom: 1px solid var(--border-subtle, #D1D5DB);
}

.industrial-tabs .v-tab {
  text-transform: none;
  font-weight: 500;
  letter-spacing: 0.02em;
  font-size: 0.875rem;
}

.industrial-tabs .v-tab--active {
  color: var(--accent-amber, #D97706) !important;
  font-weight: 600;
}

.industrial-tabs .v-tabs-slider {
  background-color: var(--accent-amber, #D97706) !important;
  height: 3px !important;
}

.service-content-panel {
  background: var(--surface-panel, #fff);
  border: 1px solid var(--border-subtle, #D1D5DB);
  border-radius: var(--radius-panel, 4px);
  margin-top: 8px;
}
</style>
